// src/services/ewcs/index.js
import axios from '../axiosInstance';

export async function getEwcs({ search = '', pageSize = 50, lastId = null, signal = null } = {}) {
    const { data } = await axios.get('/Ewcs/getEwcs', { params: { search, pageSize, lastId }, signal });
    return data; // { items, lastId, hasMore }
}
